/* eslint-ignore */
// @ts-nocheck
import React from 'react';

import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { TourProvider } from 'hooks/useTour';
import { MFAContextProvider } from 'hooks/useMFA';
import theme from 'styles/theme';
import { AuthProvider } from 'hooks/authHook';
import { DocumentationOSProvider } from 'hooks/useDocumentationOS';
import { NotificationsContextProvider } from 'hooks/useNotifications';
import { store } from '../store';

// eslint-disable-next-line react/prop-types
const AppProviders = ({ children }) => (
  <Provider store={store}>
    <AuthProvider>
      <MFAContextProvider>
        <NotificationsContextProvider>
          <TourProvider>
            <DocumentationOSProvider>
              <ThemeProvider theme={theme}>
                <ToastContainer
                  position="top-right"
                  autoClose={10000}
                  hideProgressBar={false}
                  rtl={false}
                  newestOnTop
                  closeOnClick
                  pauseOnVisibilityChange
                  draggable
                  pauseOnHover
                />
                {children}
              </ThemeProvider>
            </DocumentationOSProvider>
          </TourProvider>
        </NotificationsContextProvider>
      </MFAContextProvider>
    </AuthProvider>
  </Provider>
);

export default AppProviders;
